import React from 'react';

import { Container } from './styles';

function Footer() {
  return (
    <Container>
      CliqueRetire {new Date().getFullYear()} - Todos os Direitos Reservados
    </Container>
  );
}

export default Footer;
